import {
  getEducationOptions,
  getWorkSituationOptions,
} from "./formElementsOptions";

import Hint from "@storeblocks/hint";
import { Select } from "Components/Form/Select";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { workSituationFormElementsActive } from "./activeFormElements";
import { AdviceProductDetailsFormValues } from "./interfaces";
import { FormGroupWrap } from "./styled";

interface Props {
  formProps: FormikProps<AdviceProductDetailsFormValues>;
  formText: any;
  lang: string;
}
export const WorkFormElements = ({
  formProps,
  formText,
  lang,
}: Props): React.ReactElement => {
  const isAdvisor = useIsAdvisorSelector();
  const aboutYou = formText.aboutYou;

  return (
    <FormGroupWrap>
      <Select
        large
        id="workSituation"
        name="workSituation"
        label={aboutYou.workSituation.label[lang]}
        hint={aboutYou.workSituation.hint[lang]}
        options={getWorkSituationOptions(aboutYou.workSituation.options, lang)}
        error={getError("workSituation", formProps)}
      />
      <Hint maxLines={2} readMoreLabel="Se hint" readLessLabel="Lukk hint">
        {isAdvisor
          ? aboutYou.workSituation.notWorkingAdvisorNote[lang]
          : aboutYou.workSituation.notWorkingCustomerNote[lang]}
      </Hint>
      {workSituationFormElementsActive(formProps.values.workSituation) && (
        <div style={{ marginTop: "32px" }}>
          <Select
            large
            id="education"
            name="education"
            label={aboutYou.education.label[lang]}
            hint={aboutYou.education.hint[lang]}
            options={getEducationOptions(aboutYou.education.options, lang)}
            error={getError("education", formProps)}
          />
        </div>
      )}
    </FormGroupWrap>
  );
};
